import { ActionLabel } from '../../../data';
import NavigateIcon from '../../../../../../assets/icons/redirect.svg?react';
import { useNavigate } from 'react-router-dom';

export const AIFMReportColumn = ({ period, workflowId }) => {
  const navigate = useNavigate();

  const onOpenDrawer = () => {
    const el = period.jurisdictions[0];
    const natCode = el.reporting_member_state;
    const isFCA = natCode === 'UK' || natCode === 'uk';

    if (isFCA) navigate(`/report/fca/uk/${workflowId}/${period.id}?jurisdictionId=${el.id}`);
    else
      navigate(
        `/report/esma/${natCode?.toLowerCase()}/${workflowId}/${period.id}?jurisdictionId=${el.id}`
      );
  };

  if (period.report_progress_status === 'In progress')
    return (
      <ActionLabel
        label="View Report"
        color="#40C057"
        onClick={onOpenDrawer}
        rightIcon={<NavigateIcon />}
      />
    );

  return (
    <ActionLabel
      label="View Report"
      color="#40C057"
      onClick={onOpenDrawer}
      rightIcon={<NavigateIcon />}
    />
  );
};
